import { render, staticRenderFns } from "./LimitedReleaseSchedule.vue?vue&type=template&id=450928d3&"
import script from "./LimitedReleaseSchedule.vue?vue&type=script&lang=js&"
export * from "./LimitedReleaseSchedule.vue?vue&type=script&lang=js&"
import style0 from "./LimitedReleaseSchedule.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports